import { SVGProps, Ref, forwardRef } from 'react';

export const BookOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.914 14.269q.544.113 1.086.231.543-.119 1.087-.231c.976-.205 1.952-.41 2.913-.68 3.5-.989 4-1.675 4-5.49V5.19c0-3.816-.5-4.22-4-3.232-.967.273-1.923.592-2.878.912q-.561.188-1.122.372-.562-.185-1.126-.374c-1.128-.377-2.258-.755-3.407-1.055C.448 1.024 0 1.578 0 5.19V8.1c0 3.815.5 4.502 4 5.49.96.27 1.938.475 2.914.68M7.3 4.487l-.904-.301c-1.117-.374-2.184-.73-3.284-1.018-.737-.193-1.188-.266-1.468-.268l-.064.001a2 2 0 0 0-.081.352c-.07.428-.099 1.043-.099 1.938V8.1c0 1.976.165 2.632.419 2.98.239.328.755.652 2.561 1.162.91.257 1.819.447 2.778.648l.142.03zm1.4 8.432.143-.03c.96-.201 1.865-.391 2.777-.648 1.806-.51 2.322-.834 2.561-1.162.254-.348.419-1.004.419-2.98V5.19c0-.948-.033-1.579-.11-2.003a2 2 0 0 0-.07-.287 2 2 0 0 0-.211.006c-.389.03-.96.154-1.829.4-.933.263-1.84.566-2.782.881l-.898.299z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BookOutlinedSize16Glyph.displayName = 'BookOutlinedSize16Glyph';
